import {useState} from 'react';
import {repairRequestQuery, repairResponse} from '../models/repair.model';
import {getRepairInfo} from '../services/repair.service';

export const useGetLaptopRepairAsync = () => {
    const [laptopRepair, setLaptopRepair] = useState<repairResponse>({} as repairResponse);
    const [isGetRepairLoading, setIsGetRepairLoading] = useState<boolean>(true);

    const fetchRepair = (query: repairRequestQuery) => {
        setIsGetRepairLoading(true);
        getRepairInfo(query).then((res) => {
            setLaptopRepair(res);
            setIsGetRepairLoading(false);
        });
    };

    return {
        laptopRepair,
        isGetRepairLoading,
        fetchRepair
    };

};